import { memo, ReactNode } from 'react'
import { Box, ButtonBase, Typography } from '@mui/material'
import ThinArrowRightIcon from '../../assets/icons/ThinArrowRightIcon'

type Props = {
    title: string
    meta?: ReactNode
    onClick?: () => void
    /** Leading 18px icon or image; the slot is skipped when absent. */
    icon?: ReactNode
    /** Accent the title (e.g. "See all results"). */
    emphasis?: boolean
    last?: boolean
    'data-event'?: string
}

/** Flat, divider-separated list row for content lists (folders, articles, search results). */
const SupportListItem = ({ title, meta, onClick, icon, emphasis, last, ...dataProps }: Props) => (
    <ButtonBase
        onClick={onClick}
        {...dataProps}
        sx={{
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            textAlign: 'left',
            gap: 1.25,
            px: 0.75,
            py: 1.125,
            mx: -0.75,
            boxSizing: 'content-box',
            borderRadius: 1,
            borderBottom: last ? 0 : 1,
            borderColor: 'divider',
            color: emphasis ? 'var(--primary)' : 'text.primary',
            '&:hover': { bgcolor: 'action.hover' },
            '&.Mui-focusVisible': { bgcolor: 'action.hover' }
        }}
    >
        {icon ? (
            <Box sx={{ width: 20, display: 'flex', justifyContent: 'center', color: 'text.secondary', flexShrink: 0, '& svg': { fontSize: 18 } }}>
                {icon}
            </Box>
        ) : null}
        <Box sx={{ minWidth: 0, flex: 1 }}>
            <Typography variant="body2" fontWeight={emphasis ? 500 : 400} sx={{ lineHeight: 1.4 }}>
                {title}
            </Typography>
            {meta ? (
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.25 }}>
                    {meta}
                </Typography>
            ) : null}
        </Box>
        <ThinArrowRightIcon sx={{ fontSize: 16, color: 'text.tertiary', flexShrink: 0 }} />
    </ButtonBase>
)

export default memo(SupportListItem)
